import { FilterFilled, SearchOutlined } from "@ant-design/icons";
import { Collapse, Typography } from "antd";
import { useEffect, useState, useContext } from "react";
import CustomFormItemsHorizontal from "../common/CustomFormItemsHorizontal";
import useFetch from "../../hooks/useFetch";
import { IndexContext } from "../../context/IndexContext";
import dayjs from "dayjs";

const { Text } = Typography;

export default function BillingFilter({
  form,
  applyFilter,
}) {
  const [activeKey, setActiveKey] = useState(1);
  const [fetchWrapper] = useFetch();

  const [siteCommissioningDate, setSiteCommissioningDate] = useState(dayjs());
  const { siteSelected } = useContext(IndexContext);

  useEffect(() => {
    if (siteSelected) {
      getSiteCommissioningDate();
    }
  }, [siteSelected]);

  function getSiteCommissioningDate() {
    fetchWrapper({
      endpoint_url: "trending/getSiteCommissioningDate",
      body: {
        site_id: siteSelected,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setSiteCommissioningDate(dayjs(fetch_output.site_commissioning_date));
        }
      },
    });
  }

  const items = [
    {
      key: 1,
      label: (
        <>
          <FilterFilled />
          <Text strong className="ml-2">FILTER</Text>
        </>
      ),
      children: (
        <CustomFormItemsHorizontal
          submitIcon={<SearchOutlined />}
          submitText={"Search"}
          onFinish={applyFilter}
          form={form}
          config={[
            {
              name: "month",
              label: "Select Month",
              type: "datetime",
              picker: "month",
              disabled: false,
              minDate: siteCommissioningDate,
              maxDate: dayjs(),
              isDateOnly: true,
              rules: [
                {
                  required: true,
                  message: "Please select a valid month.",
                },
                {
                  validator: (_, value) => {
                    if (value && value.isBefore(siteCommissioningDate, "month")) {
                      return Promise.reject(
                        new Error("Selected month is before site's commissioning date.")
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ],
            },
          ]}
        />
      ),
    },
  ];

  return (
    <Collapse
      expandIconPosition="end"
      defaultActiveKey={activeKey}
      size="middle"
      onChange={(key) => setActiveKey(key)}
      items={items}
    />
  );
}
